import { render, staticRenderFns } from "./ReportsManager.vue?vue&type=template&id=07db041c&"
import script from "./ReportsManager.vue?vue&type=script&lang=js&"
export * from "./ReportsManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports